import { render, staticRenderFns } from "./avc.vue?vue&type=template&id=0f7afc63&scoped=true"
import script from "./avc.vue?vue&type=script&lang=js"
export * from "./avc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7afc63",
  null
  
)

export default component.exports